import { textStylesSelector } from "./textStyleSelector";
export const getTextGridImageItems = (componentData) => {
    const items = {};
    items.bgColor = componentData?.fields?.backgroundColour;
    items.title = componentData?.fields?.elements?.[0]?.fields?.title;
    items.description = componentData?.fields?.elements?.[0]?.fields?.description;
    items.images = componentData?.fields?.elements?.map(el => {
        return {
            image: {
                url: el?.fields?.image?.fields?.file?.url,
                title: el?.fields?.image?.fields?.title
            }
        };
    });

    const {titleStyle} = textStylesSelector(componentData);

    return {
        bgColor: items.bgColor,
        title: items.title,
        description: items.description,
        images: items.images,
        titleStyle: titleStyle?.fields,
    };
};
